import { TILE_SIZE, SCALE } from "../../utils/constants";
import { translate } from "../../utils/localization";
import * as Controller from "../Controller/Controller";
import DialogOptions from "../DialogOptions";
import UI from "../UI";


const TRANSITION_DURATION = 500;
class Dialogs {
  constructor(scene) {
    this.scene = scene;
    this.tnContainer = null;
    this.participantSprites = {};
    this.conversation = {};
    this.currentDialogIndex = 0;
    this.isShowing = false;
    this.isFullTextDisplayed = false;
    this.dialogOptions = new DialogOptions(this.scene);
    this.showDialog = this.showDialog.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.updateCharacterName = this.updateCharacterName.bind(this);
    this.tIDs = [];
  }

  mount() {
    this.tIDs.push(
      setTimeout(
        () =>
          this.scene.input.keyboard.addListener("keydown", this.handleKeyDown),
        TRANSITION_DURATION
      )
    );

    // this.scene.events.on('dialogue:show', this.showDialog)
    // this.scene.events.on('dialogue:hide', this.hideDialog)
  }
  unmount() {
    this.tIDs.forEach((id) => clearTimeout(id));
    const l = this.scene.children.getByName("layer_hud");
    if (l) {
      l.destroy();
    }
    const c = this.scene.children.getByName("dialog_tn_container");
    if (c) {
      c.destroy();
    }
    const p = this.scene.children.getByName("placeholder_text");
    if (p) {
      p.destroy();
    }
    if (this.overlay) {
      this.overlay.destroy();
    }
    if (this.topWindowboxing) {
      this.topWindowboxing.destroy();
    }
    if (this.bottomWindowboxing) {
      this.bottomWindowboxing.destroy();
    }
  }

  handleKeyDown(event) {
    // enter when full text displayed (otherwise is fast forward) as options are hidden (otherwise is option selection)
    if (
      Controller.isConfirm(event.key) &&
      this.isFullTextDisplayed &&
      !this.dialogOptions.visible
    ) {
      if (this.currentDialogIndex < this.conversation.length - 1) {
        // next page
        // this.showMessage(this.conversation[++this.currentDialogIndex]);
      } else {
        this.scene.events.emit("dialogue:hide");
        // this.scene.input.keyboard.removeListener('keydown', onNextPage)
      }
    }
  }

  hideDialog() {
    this.scene.input.keyboard.removeListener("keydown", this.handleKeyDown);

    const retVal = new Promise((res) => {
      const map = this.scene.children.list.find(
        (ch) => ch.name === "layer_hud"
      ).tilemap;
      this.clearText();
      this.dialogOptions.unmount();
      this.scene.tweens.add({
        targets: [map.layers[0].tilemapLayer, this.tnContainer],
        y: UI.tileToScreen(-7),
        duration: 500,
        ease: "Back.In",
        onComplete: () => {
          // this.scene.levels?.current?.resume()
          this.isShowing = false;
          res();
        },
      });
    });

    return retVal;
  }

  showDialog({ participants, participantNames = [], conversation }) {
    this.isShowing = true;
    this.conversation = conversation;
    this.currentDialogIndex = 0;

    // this.scene.levels?.current?.pause()
    this.prepareHUD(participants, participantNames);
    this.prepareText();

    const map = this.scene.children.list.find(
      (ch) => ch.name === "layer_hud"
    ).tilemap;
    map.layers[0].tilemapLayer.y = this.tnContainer.y = UI.tileToScreen(-8);

    this.scene.tweens.add({
      targets: this.overlay,
      alpha: 0.4,
      duration: TRANSITION_DURATION,
      ease: "Cubic.Out",
    });
    this.scene.tweens.add({
      targets: [map.layers[0].tilemapLayer, this.tnContainer],
      y: UI.tileToScreen(4),
      duration: TRANSITION_DURATION,
      ease: "Cubic.Out",
      onComplete: () => {
        this.dialogOptions.mount();
        // let lastDialog = conversation.shift()

        this.showMessage(this.conversation[this.currentDialogIndex]);
      },
    });
  }

  fullTextDisplayed() {
    this.isFullTextDisplayed = true;
    this.scene.events.emit("dialogue:message_shown", this.currentDialogIndex);
    // show options
    const onlyOnePageOption = {
      slot1: {
        label: translate("menu.dialog_options.close"),
        slot: 1,
        onSelect: () => this.scene.events.emit("dialogue:hide"),
      },
    };
    const moreThanOnePageOption = {
      slot1: {
        label: translate("menu.dialog_options.story"),
        slot: 1,
        // next page
        onSelect: () =>
          this.showMessage(this.conversation[++this.currentDialogIndex]),
      },
      slot3: {
        label: translate("menu.dialog_options.close"),
        slot: 3,
        onSelect: () => this.scene.events.emit("dialogue:hide"),
      },
    };
    const defaultPageOption = {
      slot2: {
        label: translate("menu.dialog_options.next"),
        slot: 2,
        // next page
        onSelect: () =>
          this.showMessage(this.conversation[++this.currentDialogIndex]),
      },
      slot3: {
        label: translate("menu.dialog_options.close"),
        slot: 3,
        onSelect: () => this.scene.events.emit("dialogue:hide"),
      },
    };
    const lastPageOption = {
      slot3: {
        label: translate("menu.dialog_options.close"),
        slot: 3,
        onSelect: () => this.scene.events.emit("dialogue:hide"),
      },
    };
    const options = {
      ...(this.conversation.length === 1 ? onlyOnePageOption : {}),
      ...(this.conversation.length > 1 && this.currentDialogIndex === 0
        ? moreThanOnePageOption
        : {}),
      ...(this.currentDialogIndex > 0 &&
      this.currentDialogIndex < this.conversation.length - 1
        ? defaultPageOption
        : {}),
      ...(this.currentDialogIndex === this.conversation.length - 1 &&
      this.conversation.length > 1
        ? lastPageOption
        : {}),
      ...(this.conversation[this.currentDialogIndex].options || {}),
    };
    this.dialogOptions.show(options);
  }

  showMessage(message) {
    this.clearText();
    this.dialogOptions.hide();
    this.writeText(message.text);

    const c = this.scene.children.getByName("dialog_tn_container");
    Object.keys(this.participantSprites).forEach((k) => {
      if (k === message.who) {
        // participantSprites[k].alpha = 1
        this.participantSprites[k].clearTint();
        c.list.find((el) => el.name === `char_${k}_text_to_remove`).clearTint();
      } else {
        // participantSprites[k].alpha = 0.5
        this.participantSprites[k].setTint(0x333333);
        const txt = c.list.find((el) => el.name === `char_${k}_text_to_remove`);
        txt?.setTint(0x999999);
      }
    });
  }

  prepareHUD(participants, participantNames) {
    this.overlay = this.scene.add.graphics();
    this.overlay.clear();
    this.overlay.fillStyle(0x000000, 1);
    this.overlay.fillRect(0, 0, UI.tileToScreen(20), UI.tileToScreen(20));
    this.overlay.alpha = 0;
    this.overlay.setScrollFactor(0);

    // Creating a blank tilemap with dimensions matching the dungeon
    const map = this.scene.make.tilemap({
      tileWidth: 20,
      tileHeight: 20,
      width: 20,
      height: 20,
    });

    // addTilesetImage: function (tilesetName, key, tileWidth, tileHeight, tileMargin, tileSpacing, gid)
    let tileset = map.addTilesetImage("hud-tiles", "hud-tiles", 20, 20, 1, 2);

    let layer = map.createBlankLayer("layer_hud", tileset);
    layer.name = "layer_hud";
    layer.depth = 15;
    layer.setScrollFactor(0);
    layer.setScale(SCALE);

    // Fill with black tiles
    // layer.fill(1)
    let p, tn, charName;
    this.tnContainer = this.scene.add.container(0, 0);
    this.tnContainer.depth = 20;
    this.tnContainer.name = "dialog_tn_container";
    // this.tnContainer.setScale(SCALE)
    // this.tnContainer.y = -this.scene.renderer.height/2
    switch (participants.length) {
      case 2:
        if (participants[1]) {
          p = participants[1];
          tn = this.scene.add
            .sprite(0, 0)
            .play(p)
            .setOrigin(0, 0.25)
            .setScale(SCALE);
          tn.name = `${p}_tn_to_remove`;
          tn.x = UI.tileToScreen(17) + UI.pixelToScreen(10);
          tn.y = UI.tileToScreen(3) + UI.pixelToScreen(2);
          tn.setScrollFactor(0);
          tn.setFlipX(true);
          this.tnContainer.add(tn);
          this.participantSprites[p] = tn;
        }

        /// TN MIDDLE RIGHT
        Dialogs.drawWindow(map, { w: 3, h: 2, x: 17, y: 3 });
        // NAME
        charName = this.scene.add
          .text(
            tn.x - UI.tileToScreen(2) * 0.25,
            tn.y + UI.tileToScreen(2) * 0.8,
            participantNames[1] || "???",
            {
              fontFamily: "GameGirl",
              fill: "#ffffff",
              align: "right",
            }
          )
          .setScale(SCALE / 2)
          .setScrollFactor(0);
        charName.name = `char_${p}_text_to_remove`;
        this.tnContainer.add(charName);
      // eslint-disable-next-line no-fallthrough
      case 1:
        if (participants[0]) {
          p = participants[0];
          tn = this.scene.add
            .sprite(0, 0)
            .play(p)
            .setOrigin(0, 0.25)
            .setScale(SCALE);
          tn.name = `${p}_tn_to_remove`;
          tn.x = UI.tileToScreen(0) + UI.pixelToScreen(12);
          tn.y = UI.tileToScreen(3) + UI.pixelToScreen(2);
          tn.setScrollFactor(0);
          this.tnContainer.add(tn);
          this.participantSprites[p] = tn;
        }
        /// TN MIDDLE LEFT
        Dialogs.drawWindow(map, { w: 3, h: 2, x: 0, y: 3 });
        // NAME
        charName = this.scene.add
          .text(
            tn.x - UI.tileToScreen(2) * 0.25,
            tn.y + UI.tileToScreen(2) * 0.8,
            participantNames[0] || "???",
            {
              fontFamily: "GameGirl",
              fill: "#ffffff",
              align: "right",
            }
          )
          .setScale(SCALE / 2)
          .setScrollFactor(0);
        charName.name = `char_${p}_text_to_remove`;
        this.tnContainer.add(charName);
        break;
      case 4:
        /// TN LOWER RIGHT
        if (participants[3]) {
          p = participants[3];
          tn = this.scene.add
            .sprite(0, 0)
            .play(p)
            .setOrigin(0, 0.25)
            .setScale(SCALE);
          tn.name = `${p}_tn_to_remove`;
          tn.x = UI.tileToScreen(17) + UI.pixelToScreen(10);
          tn.y = UI.tileToScreen(4) + UI.pixelToScreen(2);
          tn.setScrollFactor(0);
          tn.setFlipX(true);
          this.tnContainer.add(tn);
          this.participantSprites[p] = tn;
        }
        Dialogs.drawWindow(map, { w: 3, h: 2, x: 17, y: 4 });
        // NAME
        charName = this.scene.add
          .text(
            tn.x - UI.tileToScreen(2) * 0.25,
            tn.y + UI.tileToScreen(2) * 0.8,
            participantNames[3] || "???",
            {
              fontFamily: "GameGirl",
              fill: "#ffffff",
              align: "right",
            }
          )
          .setScale(SCALE / 2)
          .setScrollFactor(0);
        charName.name = `char_${p}_text_to_remove`;
        this.tnContainer.add(charName);
      // eslint-disable-next-line no-fallthrough
      case 3:
        /// TN UPPER LEFT
        if (participants[0]) {
          p = participants[0];
          tn = this.scene.add
            .sprite(0, 0)
            .play(p)
            .setOrigin(0, 0.25)
            .setScale(SCALE);
          tn.name = `${p}_tn_to_remove`;
          tn.x = UI.tileToScreen(0) + UI.pixelToScreen(12);
          tn.y = UI.tileToScreen(0) + UI.pixelToScreen(2);
          tn.setScrollFactor(0);
          this.tnContainer.add(tn);
          this.participantSprites[p] = tn;
        }
        Dialogs.drawWindow(map, { w: 3, h: 2, x: 0, y: 0 });
        // NAME
        charName = this.scene.add
          .text(
            tn.x - UI.tileToScreen(2) * 0.25,
            tn.y + UI.tileToScreen(2) * 0.8,
            participantNames[0] || "???",
            {
              fontFamily: "GameGirl",
              fill: "#ffffff",
              align: "right",
            }
          )
          .setScale(SCALE / 2)
          .setScrollFactor(0);
        charName.name = `char_${p}_text_to_remove`;
        this.tnContainer.add(charName);

        /// TN BOTTOM LEFT
        if (participants[2]) {
          p = participants[2];
          tn = this.scene.add
            .sprite(0, 0)
            .play(p)
            .setOrigin(0, 0.25)
            .setScale(SCALE);
          tn.name = `${p}_tn_to_remove`;
          tn.x = UI.tileToScreen(0) + UI.pixelToScreen(12);
          tn.y = UI.tileToScreen(4) + UI.pixelToScreen(2);
          tn.setScrollFactor(0);
          this.tnContainer.add(tn);
          this.participantSprites[p] = tn;
        }

        Dialogs.drawWindow(map, { w: 3, h: 2, x: 0, y: 4 });
        // NAME
        charName = this.scene.add
          .text(
            tn.x - UI.tileToScreen(2) * 0.25,
            tn.y + UI.tileToScreen(2) * 0.8,
            participantNames[2] || "???",
            {
              fontFamily: "GameGirl",
              fill: "#ffffff",
              align: "right",
            }
          )
          .setScale(SCALE / 2)
          .setScrollFactor(0);
        charName.name = `char_${p}_text_to_remove`;
        this.tnContainer.add(charName);

        /// TN UPPER RIGHT
        if (participants[1]) {
          p = participants[1];
          tn = this.scene.add
            .sprite(0, 0)
            .play(p)
            .setOrigin(0, 0.25)
            .setScale(SCALE);
          tn.name = `${p}_tn_to_remove`;
          tn.x = UI.tileToScreen(17) + UI.pixelToScreen(10);
          tn.y = UI.tileToScreen(0) + UI.pixelToScreen(2);
          tn.setScrollFactor(0);
          tn.setFlipX(true);
          this.tnContainer.add(tn);
          this.participantSprites[p] = tn;
        }
        Dialogs.drawWindow(map, { w: 3, h: 2, x: 17, y: 0 });
        // NAME
        charName = this.scene.add
          .text(
            tn.x - UI.tileToScreen(2) * 0.25,
            tn.y + UI.tileToScreen(2) * 0.8,
            participantNames[1] || "???",
            {
              fontFamily: "GameGirl",
              fill: "#ffffff",
              align: "right",
            }
          )
          .setScale(SCALE / 2)
          .setScrollFactor(0);
        charName.name = `char_${p}_text_to_remove`;
        this.tnContainer.add(charName);
        break;
      default:
    }

    Dialogs.drawWindow(map, { w: 14, h: 7, x: 3, y: 0 });
  }

  updateCharacterName(key = "closeUp_Mary", name = "???") {
    const c = this.scene.children.getByName("dialog_tn_container");
    const charName = c.list.find(
      (el) => el.name === `char_${key}_text_to_remove`
    );
    charName.setText(name);
  }

  prepareText() {
    const textObj = this.scene.add.text(
      UI.tileToScreen(3.5),
      UI.tileToScreen(4.5),
      " ",
      {
        fontFamily: "GameGirl",
        //  fontSize: "8px",
        fill: "#ffffff",
        lineSpacing: 2,
        // wordWrap: { width: MAX_CHARS_BY_LINE * 8 }
      }
    );
    textObj.setScrollFactor(0);
    textObj.displayHeight = 10 * SCALE;
    textObj.displayWidth = 10 * SCALE;
    textObj.name = "placeholder_text";
    textObj.depth = 20;
    textObj.setShadow(-1, 1);
  }

  writeText(text) {
    const charPlaceholder = this.scene.children.getByName("placeholder_text");
    this.isFullTextDisplayed = false;
    // ===========
    // prepare one big text with \n by line of 26 char length
    const MAX_CHARS_BY_LINE = 26;
    const fullText = text.join(""); // legacy for texts as array
    const paragraphs = fullText.split("\n"); // respect \n into text
    const lines = [];
    while (paragraphs.length) {
      let line = ""; // new line
      const paragraphWords = paragraphs.shift().split(" ");
      while (paragraphWords.length) {
        const prevLine = line; // save current line
        const nextWord = paragraphWords.shift();
        line += nextWord + " "; // build new line
        if (line.trim().length > MAX_CHARS_BY_LINE) {
          // new line is bigger than mx char by line
          lines.push(prevLine); // store prev line
          paragraphWords.unshift(nextWord); // restore last word for next line
          line = "";
        }
      }
      lines.push(line);
    }
    let letters = lines.join("\n");
    // ===========

    let timerId;
    const fastForward = () => {
      clearTimeout(timerId);
      if (letters.length) {
        putLetter(letters.length);
      }
    };
    const putLetter = (len = 1) => {
      const char = letters.substring(0, len);
      letters = letters.substring(len);
      charPlaceholder.setText(charPlaceholder.text + char);
      if (letters.length) {
        timerId = setTimeout(
          () => putLetter(1),
          [".", "!", "?"].includes(char) ? 500 : 50
        );
        this.tIDs.push(timerId);
      } else {
        this.scene.input.keyboard.off("keyup", fastForward);
        this.fullTextDisplayed();
      }
    };
    putLetter();
    this.tIDs.push(
      setTimeout(
        () =>
          this.scene.input.keyboard.once("keyup", (event) => {
            if (Controller.isConfirm(event.key) || Controller.isCancel(event.key)) {
              fastForward();
            }
          }),
        500
      )
    );
  }

  clearText() {
    this.scene.children.getByName("placeholder_text").setText("");
    // this.scene.children.list.filter(el => el.name === 'placeholder_text').forEach(el => el.setText(""))
  }

  static drawWindow(map, { w, h, x, y }) {
    const THEME = 6;
    const TILES = {
      TOP_LEFT: 0 + THEME,
      TOP_MIDDLE: 1 + THEME,
      TOP_RIGHT: 2 + THEME,
      LEFT: 10 + THEME,
      MIDDLE: 11 + THEME,
      RIGHT: 12 + THEME,
      BOTTOM_LEFT: 20 + THEME,
      BOTTOM_MIDDLE: 21 + THEME,
      BOTTOM_RIGHT: 22 + THEME,
    };
    for (let j = 0; j < h; j++) {
      for (let i = 0; i < w; i++) {
        let tile;
        if (i === 0 && j === 0) {
          tile = TILES.TOP_LEFT;
        }
        if (i > 0 && i < w - 1 && j === 0) {
          tile = TILES.TOP_MIDDLE;
        }
        if (i === w - 1 && j === 0) {
          tile = TILES.TOP_RIGHT;
        }

        if (i === 0 && j > 0 && j < h - 1) {
          tile = TILES.LEFT;
        }
        if (i > 0 && i < w - 1 && j > 0 && j < h - 1) {
          tile = TILES.MIDDLE;
        }
        if (i === w - 1 && j > 0 && j < h - 1) {
          tile = TILES.RIGHT;
        }

        if (i === 0 && j === h - 1) {
          tile = TILES.BOTTOM_LEFT;
        }
        if (i > 0 && i < w - 1 && j === h - 1) {
          tile = TILES.BOTTOM_MIDDLE;
        }
        if (i === w - 1 && j === h - 1) {
          tile = TILES.BOTTOM_RIGHT;
        }

        map.putTileAt(tile, i + x, j + y);
      }
    }
  }
}

export default Dialogs;
